import headerImage from "../../asset/images/aboutUs/header-photo.png";
import {
  ABOUT_US_PAGE_TEXT,
  COMPANY_PROFILE,
} from "../../constants/translations";
const Intro = () => {
  return (
    <section className="about-us-header">
      <div className="about-us-img">
        <img src={headerImage} alt="Ship" width={640} height={360} />
      </div>
      <div className="about-us-texts">
        <div className="content-controller">
          <h1 className="page-title">{COMPANY_PROFILE}</h1>
          <p className="about-us-text">{ABOUT_US_PAGE_TEXT}</p>
        </div>
      </div>
    </section>
  );
};

export default Intro;
